import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyledReloadButton} from './StyledReloadButton';
import {ReloadIcon} from '../../../../icons';

const ReloadButton = ({
  ...rest
}) => {
  const [t] = useTranslation('main');

  return (
    <StyledReloadButton
      icon={<ReloadIcon />}
      tooltipProps={{ title: t('refresh') }}
      {...rest}
    />
  );
}


export default ReloadButton;
